module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/246.5a583ab7.png";